import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const PauseIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-pause', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path d='M4 13.25C4 13.6647 4.37312 14 4.83472 14C5.29633 14 5.66945 13.6647 5.66945 13.25V2.75C5.66945 2.33525 5.29633 2 4.83472 2C4.37312 2 4 2.33525 4 2.75V13.25Z' />
      <path d='M10.3306 13.25C10.3306 13.6647 10.7037 14 11.1653 14C11.6269 14 12 13.6647 12 13.25V2.75C12 2.33525 11.6269 2 11.1653 2C10.7037 2 10.3306 2.33525 10.3306 2.75V13.25Z' />
    </svg>
  );
};

export default PauseIcon;
